// PageContainer — max-width centered page wrapper with responsive gutters and
// consistent vertical rhythm between sections. Wraps the content of every
// route below the header.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './page-container.css';

export function PageContainer({ maxWidth = 1200, className, style, children, ...rest }) {
  return (
    <div
      className={cx('page-container', className)}
      style={{ '--page-max': `${maxWidth}px`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}

PageContainer.propTypes = {
  maxWidth: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default PageContainer;
